module.exports = __webpack_public_path__ + "static/media/lowresportfolio-33.e45ce3b2.jpg";